export const questions = [
  {
    Id: 1,
    Question: "What is Time Shoppy?",
    Answer:
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nemo velit, magnam quasi hic inventore aliquam. Odio consectetur, vitae deserunt libero dolore tempore provident perferendis earum, eos quo consequatur quia quod?",
  },

  {
    Id: 2,
    Question: "Who pays the tax?",
    Answer:
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nemo velit, magnam quasi hic inventore aliquam. Odio consectetur, vitae deserunt libero dolore tempore provident perferendis earum, eos quo consequatur quia quod?",
  },
  {
    Id: 3,
    Question: "How much does it cost to upload products for sale?",
    Answer: "Creating an account and uploading products for sale are free.",
  },
  {
    Id: 4,
    Question: "What happens if a delivery is not made on time?",
    Answer:
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nemo velit, magnam quasi hic inventore aliquam. Odio consectetur, vitae deserunt libero dolore tempore provident perferendis earum, eos quo consequatur quia quod?",
  },
  {
    Id: 5,
    Question: "How many days does it take for an order to be delievered?",
    Answer:
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nemo velit, magnam quasi hic inventore aliquam. Odio consectetur, vitae deserunt libero dolore tempore provident perferendis earum, eos quo consequatur quia quod?",
  },
];
